import {useTranslation} from "react-i18next";
import {dibAppApi} from "../../dibAppApi/dibAppApi";
import classes from "./SupplierInfo.module.css";

const DIB_SUPPLIER_ID = "1";

export const SupplierInfo = ({
    resourceId,
    segmentId,
}: {
    resourceId: string;
    segmentId: string | undefined;
}) => {
    const {data: documentData} = dibAppApi.endpoints.getDocument.useQuery({
        resourceId,
        segmentId,
    });
    const {t} = useTranslation();

    console.log("FOO!");

    const supplier = documentData?.supplier;
    const supplierId = documentData?.supplierId;

    if (!supplier || supplierId === DIB_SUPPLIER_ID) {
        return null;
    }

    return (
        <div className={classes.infoSection}>
            <h2 className={classes.sectionHeader}>
                {t("Word.Info", {defaultValue: "Info"})}
            </h2>
            <span className={classes.supplierName}>{supplier}</span>
        </div>
    );
};
